import { createReducer, on } from '@ngrx/store';

import * as PaymentActions from './payment.actions';
import { initialPaymentState, PaymentState } from './payment.state';

const paymentReducer = createReducer<PaymentState>(
  initialPaymentState,
  on(PaymentActions.fetchPayments, (state) => ({
    ...state,
    fetchedAt: null,
  })),
  on(PaymentActions.fetchCurrentPaymentById, (state) => ({
    ...state,
    fetchedAt: null,
  })),
  on(PaymentActions.fetchCurrentTransactionById, (state) => ({
    ...state,
    fetchedAt: null,
  })),
  on(PaymentActions.fetchPaymentsSuccess, (state, { payments }) => ({
    ...state,
    payments,
    fetchedAt: new Date(),
  })),
  on(PaymentActions.fetchCurrentPaymentByIdSuccess, (state, { payment }) => ({
    ...state,
    payment,
    fetchedAt: new Date(),
  })),
  on(PaymentActions.fetchCurrentTransactionByIdSuccess, (state, { transaction }) => ({
    ...state,
    transaction,
    fetchedAt: new Date(),
  }))
);

export { paymentReducer };
